import React from "react";
import OtpInput from "react-otp-input";

const OTPInput = ({
  OTP,
  setOTP,
  OTPFieldsNumber = 6,
  labelTitle = "Verification Pin",
}) => {
  return (
    <div className="pt-7 w-full">
      <div className="pb-2 text-subtitle text-body">{labelTitle}</div>
      <OtpInput
        value={OTP}
        onChange={setOTP}
        inputStyle={`border-2 w-full h-13 text-center text-body_lg text-subtle border-border_lighter bg-surface_subtle focus:border-brand outline-none rounded-lg `}
        containerStyle={`flex w-full justify-center items-center gap-2`}
        shouldAutoFocus
        inputStyles={{ width: "100%", marginRight: 0, height: 48 }}
        numInputs={OTPFieldsNumber}
        skipDefaultStyles
        inputType
        renderInput={(props) => <input {...props} />}
      />
    </div>
  );
};

export default OTPInput;
